var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/lib/Pagination.tsx
import { default as MuiPagination } from "@mui/material/Pagination";

// src/lib/PaginationItem.tsx
import {
  default as MuiPaginationItem
} from "@mui/material/PaginationItem";
import { NavigateNextIcon, NavigatePreviousIcon } from "@availity/mui-icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var slots = {
  first: () => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(NavigatePreviousIcon, { fontSize: "inherit", sx: { mr: ".2rem" } }),
    " First"
  ] }),
  previous: () => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(NavigatePreviousIcon, { fontSize: "inherit", sx: { mr: ".2rem" } }),
    " Prev"
  ] }),
  next: () => /* @__PURE__ */ jsxs(Fragment, { children: [
    "Next ",
    /* @__PURE__ */ jsx(NavigateNextIcon, { fontSize: "inherit", sx: { ml: ".2rem" } })
  ] }),
  last: () => /* @__PURE__ */ jsxs(Fragment, { children: [
    "Last ",
    /* @__PURE__ */ jsx(NavigateNextIcon, { fontSize: "inherit", sx: { ml: ".2rem" } })
  ] })
};
var PaginationItem = (props) => {
  return /* @__PURE__ */ jsx(MuiPaginationItem, __spreadValues({ slots }, props));
};

// src/lib/Pagination.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var getItemAriaLabel = (type, page) => {
  if (type === "page") return `Go to page ${page}`;
  return `Go to ${type} page`;
};
var Pagination = (props) => {
  return /* @__PURE__ */ jsx2(MuiPagination, __spreadProps(__spreadValues({}, props), { getItemAriaLabel, renderItem: (item) => /* @__PURE__ */ jsx2(PaginationItem, __spreadValues({}, item)) }));
};

// src/lib/ResourcePagination.tsx
import { useQuery } from "@tanstack/react-query";
var loadPage = (_0) => __async(void 0, [_0], function* ({
  page,
  itemsPerPage = 10,
  parameters = {},
  getResult,
  resource
}) {
  const data = __spreadValues({
    limit: itemsPerPage,
    offset: (page - 1) * itemsPerPage
  }, parameters.params);
  const config = resource.addParams(data, parameters);
  const resp = yield resource.postGet(data, config);
  const useGetResult = getResult || resource.getResult;
  const items = (typeof useGetResult === "function" ? useGetResult.call(resource, resp.data) : resp.data[useGetResult]) || resp.data;
  if (!Array.isArray(items)) {
    throw new TypeError(
      `Expected data to be an array but got \`${typeof items}\`. Use the \`getResult\` prop to specify how to get the data from the API response.`
    );
  }
  return {
    items,
    totalCount: resp.data.totalCount
  };
});
var useResourcePagination = ({
  page,
  itemsPerPage,
  parameters,
  getResult,
  resource
}) => useQuery(["resource", page], () => loadPage({ page, itemsPerPage, parameters, getResult, resource }));
export {
  Pagination,
  PaginationItem,
  useResourcePagination
};
